import { Paper } from "@mui/material";
import PairingRecordsChosenHead from "./PairingRecordsChosen/PairingRecordsChosenHead";
import PairingRecordsChosenTable from "./PairingRecordsChosen/PairingRecordsChosenTable";
import PairAddRecords from "./PairingRecordsChosen/PairAddRecords/PairAddRecords";
import { useSelector } from "react-redux";
import { selectUserToken } from "../../../../../features/userSlice";
import { ReceiptsEndPointLogic } from "../../../../../logic/Finance/ProviderExpense/ReceiptsEndpointLogic";
import { useSearchParams } from "react-router-dom";
import React, { useEffect } from "react";
import PairingSkeleton1 from "../helpers/components/PairingSkeleton1";
import { useDispatch } from "react-redux";
import {
  setFinancialMonthlyEarningsData,
  setSelectedCompanyToBrowseFME,
} from "../../../../../features/financeReceiptSlice";
import PairingSkeleton2 from "../helpers/components/PairingSkeleton2";
import { hasCurrencyMismatch } from "../helpers/funcs/calculateDebitAndCPAndMismatchLogicForReceipt";

const tableHeadings = {
  finance_company_name: "Company",
  receipt_date: "Date",
  receipt_id: "Receipt Number",
  receipt_amount: "Receipt Amount",
  receipt_status: "Receipt Status",
  fme: "FME",
};

const PairReceipts = () => {
  const oauthTokenHeader = useSelector(selectUserToken) as any;
  const {
    receiptData,
    financialMonthlyEarningsData,
    FMERecordsLoading,
    linkedFmesByReceipt,
  } = useSelector((state: any) => state.receipts);
  const dispatch = useDispatch();
  const [searchParams /* setSearchParams*/] = useSearchParams();
  const [loading, setLoading] = React.useState(true);
  const receiptSharedUID = React.useMemo(() => {
    return searchParams.get("receipt_shared_uid")?.split(",") || [];
  }, [searchParams]);
  const from_date = searchParams.get("from");
  const to_date = searchParams.get("to");
  const getReceipt = async () => {
    try {
      setLoading(true);
      await Promise.all([
        ReceiptsEndPointLogic.getAllReceiptData(
          oauthTokenHeader,
          from_date,
          to_date,
        ),
        ReceiptsEndPointLogic.getAllCompanies(oauthTokenHeader),
      ]);
    } catch (error: any) {
      console.error("Error fetching receipts:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getReceipt();
    return () => {
      dispatch(setFinancialMonthlyEarningsData([]));
      dispatch(setSelectedCompanyToBrowseFME(null));
    };
    // eslint-disable-next-line
  }, []);

  const rows = React.useMemo(() => {
    if (!Array.isArray(receiptData) || receiptSharedUID.length === 0) {
      return [];
    }

    return receiptData?.filter((receipt: any) =>
      receiptSharedUID.includes(receipt.receipt_shared_uid),
    );
  }, [receiptData, receiptSharedUID]);

  const mismatchedReceipts = React.useMemo(() => {
    return rows.filter((receipt: any) => {
      const fmes = linkedFmesByReceipt[receipt.receipt_shared_uid] || [];
      return hasCurrencyMismatch(receipt, fmes);
    });
  }, [rows, linkedFmesByReceipt]);

  return (
    <>
      <div>
        {loading ? (
          <PairingSkeleton1 />
        ) : (
          <Paper>
            <PairingRecordsChosenHead
              mismatchedReceipts={mismatchedReceipts}
              rows={rows}
            />
            <PairingRecordsChosenTable
              tableHeadings={tableHeadings}
              rows={rows}
            />
          </Paper>
        )}
      </div>
      <div style={{ marginTop: "10px" }}>
        {FMERecordsLoading ? (
          <PairingSkeleton2 />
        ) : (
          <>
            {financialMonthlyEarningsData.length > 0 ? (
              <PairAddRecords />
            ) : null}{" "}
          </>
        )}
      </div>
    </>
  );
};

export default PairReceipts;
